import React from 'react';
import { MANIFESTO } from '../data';

export default function Manifesto() {
  return (
    <section id="manifesto" style={{ padding: '120px 0', background: '#1a1a1a', borderTop: '1px solid rgba(255,255,255,0.07)' }}>
      <div style={{ padding: '0 12%' }}>
        <div className="fade-in">
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '11px', letterSpacing: '0.28em', color: 'rgba(250,250,248,0.35)', textTransform: 'uppercase', marginBottom: '24px' }}>
            A Letter to Whoever's Hiring
          </div>
          <h2 style={{
            fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 5vw, 56px)', fontWeight: 600,
            color: '#fafaf8', lineHeight: 1.1, letterSpacing: '-0.03em', marginBottom: '48px',
            fontStyle: 'italic',
          }}>
            {MANIFESTO.title}
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 480px), 1fr))',
            gap: '0 80px',
          }}>
            {MANIFESTO.paragraphs.map((p, i) => (
              <div
                key={i}
                style={{
                  fontFamily: 'var(--font-body)', fontSize: '17px', fontWeight: 300,
                  color: 'rgba(250,250,248,0.7)', lineHeight: 1.9, marginBottom: '28px',
                }}
              >
                {i === 0 && (
                  <span style={{
                    fontFamily: 'var(--font-display)', fontSize: '48px', fontWeight: 600,
                    color: '#e8c547', float: 'left', lineHeight: 0.85,
                    marginRight: '12px', marginTop: '4px',
                  }}>
                    {p.charAt(0)}
                  </span>
                )}
                {i === 0 ? p.slice(1) : p}
              </div>
            ))}
          </div>

          <div style={{ width: '40px', height: '2px', background: '#e8c547', margin: '48px 0 24px', opacity: 0.6 }} />
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.2em', color: 'rgba(250,250,248,0.3)', textTransform: 'uppercase' }}>
            — Mekhal Raj Rajendran
          </div>
        </div>
      </div>
    </section>
  );
}
